import { antdNotification } from '@hellodarwin/core/lib/features/providers/antd-app-provider';

import { getI18n } from 'react-i18next';

const showErrorNotification = (code: number) => {
  const { t } = getI18n();
  const message = t(`errors|${code}|message`);
  const description = t(`errors|${code}|description`);

  antdNotification.error({
    message: message ? message : 'Server Error',
    description: description ? description : 'Error code: ' + code,
  });
};

export default showErrorNotification;
